import { isFeatureFlagEnabled } from '@ipfabric/ui-components/utils/featureFlags';
import {
  type CloudConstructKind,
  type NodeGraphExtra,
  type NodeType,
  getCloudConstructKind,
  isCloudConstructNodeType,
  isNonNullable,
} from '@ipfabric/utils';

export type { CloudConstructKind };

export const isCloudConstructNode = (
  nodeType: NodeType | null,
  extra: NodeGraphExtra | null,
): boolean =>
  isNonNullable(nodeType) &&
  isCloudConstructNodeType(nodeType) &&
  typeof extra?.vendor === 'string';

/**
 * Per-construct user-facing labels used in places like the "Set up tables
 * for <construct>" dialog title (NIM-24243 AC3).
 */
export const cloudConstructLabel: { [Kind in CloudConstructKind]: string } = {
  cloudNetwork: 'Cloud Network',
  networkInterface: 'Network Interface',
  subnet: 'Subnet',
  peering: 'Cloud Network Peering',
  instance: 'Cloud Instance',
  natGateway: 'NAT Gateway',
  internetGateway: 'Internet Gateway',
};

export const getCloudConstructKindFromNode = (
  nodeType: NodeType | null,
  extra: NodeGraphExtra | null,
): CloudConstructKind | null => {
  if (!isCloudConstructNode(nodeType, extra)) {
    return null;
  }
  const kind = getCloudConstructKind(nodeType);
  // NIM-24373: if FF is not enabled, fallback to Device View
  // for cloudNetwork nodes
  if (
    kind === 'cloudNetwork' &&
    !isFeatureFlagEnabled('ENABLE_NEW_CLOUD_MODEL')
  ) {
    return null;
  }
  return kind;
};

export const getCloudConstructLabelFromNode = (
  nodeType: NodeType | null,
  extra: NodeGraphExtra | null,
): string | null => {
  const kind = getCloudConstructKindFromNode(nodeType, extra);
  return kind === null ? null : cloudConstructLabel[kind];
};
